// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_33svU","description":"hYoBw","checkbox":"nVIRG","price":"_2ob1z","date":"_28Z7t","option":"ewWmt","block":"_2y1GA"};